import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { get_interview_kit_by_id_data_action } from "../../../redux/_actions/mentor/interview.actions";

function useCreateInterviewFinal() {
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const { interviewKitData } = useSelector(
    (state) => state.get_interview_kit_by_id_data_reducer
  );

  useEffect(() => {
    if (interviewKitData?.data) {
      let data = interviewKitData?.data;
      let total_time = 0;
      let total_question = 0;
      data?.topics &&
        Array.isArray(data?.topics) &&
        data.topics.forEach((element) => {
          element?.questions &&
            element.questions.forEach(
              (item) => (total_time = item?.time_to_answer + total_time)
            );
          total_question =
            element?.questions && element.questions.length + total_question;
        });

      data["total_question"] = total_question;
      data["total_time"] = total_time;
      setFormData(data);
    }
  }, [interviewKitData]);

  useEffect(() => {
    let id = location.state;
    if (id !== null) {
      callApi(id);
    }
  }, []);

  const callApi = async (id) => {
    setLoading(true);
    await dispatch(get_interview_kit_by_id_data_action(id));
    setLoading(false);
  };

  return {
    formData,
    loading,
  };
}

export default useCreateInterviewFinal;
